import PropTypes from 'prop-types';
import { useMemo } from 'react';
import MUIAutocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const Autocomplete = ({
  helper,
  label,
  error,
  options = [],
  value,
  onChange,
  ...props
}) => {
  const selectedOption = useMemo(() => options.find((option) => option.value === value), [options, value]);
  return (
    <MUIAutocomplete
      value={selectedOption || null}
      disablePortal
      options={options}
      getOptionKey={(option) => option.value}
      getOptionLabel={(option) => option.label}
      size='small'
      renderInput={(params) => (
        <TextField
          label={label}
          error={error}
          helperText={helper}
          {...params}
        />
      )}
      {...props}
      onChange={(e, value) => onChange(value?.value || null)}
    />
  );
};

Autocomplete.propTypes = {
  helper: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
};

export default Autocomplete;
